
<ng-container *ngIf="display">
  <ng-content></ng-content>
</ng-container>
